export class QuickSearchDate {
  dateTime?: Date;
  type?: string;

  constructor(opts?: Partial<QuickSearchDate>) {
    if (opts?.dateTime != null) {
      this.dateTime = new Date(opts.dateTime);
    }
    if (opts?.type != null) {
      this.type = opts.type;
    }
  }
}
